import {useAppSelector} from "../../../redux/hooks";
import {dashboardStore} from "../store/dashboardPageStore";


export interface ISongsProgressLogic {
  passedPerformances?: number;
  starsEarnedTowardsNextSongCredit?: number;
  totalStarsRequiredByNextSongCredit?: number;
  redeemableSongCredits?: number;
}

export const useSongsProgressLogic = (): ISongsProgressLogic => {
  const {passedPerformances, redeemableSongCredits, starsEarnedTowardsNextSongCredit, totalStarsRequiredByNextSongCredit} = useAppSelector(dashboardStore.getSongsProgress);
  return {
    passedPerformances,
    redeemableSongCredits,
    starsEarnedTowardsNextSongCredit,
    totalStarsRequiredByNextSongCredit,
  };
}
